// src/components/list/DashboardDisplaySensors.tsx

import { Checkbox, FormControlLabel } from '@mui/material'

import { FolderId, FolderName, FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import { useFolderPool, useSensorPool } from '../../hooks'

type Props = {
  data: any[]
  selectedFolders: number[]
  setSelectedFolders?: (
    folders: number[] | ((prev: number[]) => number[])
  ) => void
  selectedSensors: number[]
  setSelectedSensors: (
    sensors: number[] | ((prev: number[]) => number[])
  ) => void
  presentationLevel: number
}

export const DashboardDisplaySensors = ({
  data,
  selectedFolders,
  setSelectedFolders,
  selectedSensors,
  setSelectedSensors,
  presentationLevel,
}: Props) => {
  const fPool: FolderPool = useFolderPool()
  const sPool: SensorPool = useSensorPool()

  return data.map(s => {
    const { entity_id, folder_id, name: sensorName } = s.attributes

    const fId: FolderId = Number(folder_id)
    const fRecord = fPool.find(f => Number(f.id) === fId)
    const fName: FolderName = fRecord ? fRecord.attributes.name : ''
    const label: string = `${sensorName} | Gebäude ${fName}`
    const checked: boolean = selectedSensors.includes(entity_id)

    const onChange = () => {
      if (!selectedFolders.includes(fId))
        setSelectedFolders(prev => [...prev, fId])

      const remainingSensors = sPool.some(
        s =>
          s.attributes.folder_id === fId && selectedSensors.includes(entity_id)
      )

      if (!remainingSensors && presentationLevel === 2)
        setSelectedFolders(prev => prev.filter(f => f !== fId))

      setSelectedSensors(prev =>
        prev.includes(entity_id)
          ? prev.filter(f => f !== entity_id)
          : [...prev, entity_id]
      )
    }

    const control = (
      <Checkbox checked={checked} name={label} onChange={onChange} />
    )

    return <FormControlLabel control={control} key={entity_id} label={label} />
  })
}
